import { render, staticRenderFns } from "./Base64Codec.vue?vue&type=template&id=135833cb&scoped=true"
import script from "./Base64Codec.vue?vue&type=script&lang=js"
export * from "./Base64Codec.vue?vue&type=script&lang=js"
import style0 from "./Base64Codec.vue?vue&type=style&index=0&id=135833cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135833cb",
  null
  
)

export default component.exports